import { render, staticRenderFns } from "./make-worker.vue?vue&type=template&id=3c4575bb&scoped=true&"
import script from "./make-worker.vue?vue&type=script&lang=js&"
export * from "./make-worker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4575bb",
  null
  
)

export default component.exports